import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    // MUI forces DialogContent's first-child paddingTop to 20px; add the
    // remainder so the icon sits 48px below the modal top, matching the Figma.
    marginTop: theme.spacing(7)
  },
  alertIcon: {
    width: 40,
    height: 34
  },
  title: {
    color: theme.colorPalette.green_75
  },
  intro: {
    color: theme.colorPalette.green_80
  },
  introSpacer: {
    height: theme.spacing(3)
  },
  technicalDetails: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  technicalDetailsTitle: {
    color: theme.colorPalette.green_90
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  rowLabel: {
    flex: 1,
    color: theme.colorPalette.green_75
  },
  rowValue: {
    color: theme.colorPalette.green_80,
    textAlign: 'right'
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: theme.colorPalette.beige_50
  },
  buttons: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1)
  }
}));

export default useStyles;
